import Variants from './components';

import type { DividerProps } from './Divider.d';

export const Divider = ({ variant, ...props }: DividerProps) => {
  return Variants[variant] ? Variants[variant]({ ...props }) : <Variants.Line {...props} />;
};
